import styled, { css } from 'styled-components';
import { media } from '../../../../ui';
import { Logo as LogoEmblem } from '../../../../components/insurance/booking/Style';
export const Body = styled.div.withConfig({
  displayName: "Style__Body",
  componentId: "sc-14ll30y-0"
})(["display:flex;flex-direction:row;", ""], media.xxs`
    flex-direction column;
  `);
export const Content = styled.div.withConfig({
  displayName: "Style__Content",
  componentId: "sc-14ll30y-1"
})(["", ""], media.xxs`
    margin-right: 0;
  `);
export const LogoDefault = styled.div.withConfig({
  displayName: "Style__LogoDefault",
  componentId: "sc-14ll30y-2"
})(["min-width:155px;margin-top:3px;", "{&[type=\"vuso\"]{height:24px;}}"], LogoEmblem);
export const Logo = styled(LogoDefault).withConfig({
  displayName: "Style__Logo",
  componentId: "sc-14ll30y-3"
})(["display:block;"]);
export const LogoHead = styled(LogoDefault).withConfig({
  displayName: "Style__LogoHead",
  componentId: "sc-14ll30y-4"
})(["display:none;"]);
const buttonStyle = css(["display:inline-block;height:30px;padding:5px 20px;font-size:", "px;line-height:20px;color:", ";vertical-align:middle;background-color:transparent;border:1px solid ", ";border-radius:4px;transition:all 0.28s ease-in-out;&:hover,&:focus,&:active{color:", ";text-decoration:none;background-color:", ";box-shadow:none !important;transform:none !important;}"], ({
  theme: {
    fontSize
  }
}) => fontSize.sm, ({
  theme: {
    color
  }
}) => color.black, ({
  theme: {
    color
  }
}) => color.primary, ({
  theme: {
    color
  }
}) => color.white, ({
  theme: {
    color
  }
}) => color.hover);
export const ActionLink = styled.a.withConfig({
  displayName: "Style__ActionLink",
  componentId: "sc-14ll30y-5"
})(["", ""], buttonStyle);
export const RemoveWrapper = styled.div.withConfig({
  displayName: "Style__RemoveWrapper",
  componentId: "sc-14ll30y-6"
})(["width:100%;text-align:right;button + button{margin-left:12px;}button{", "}", ""], buttonStyle, media.xxs`
    margin-left: 0;
  `);
export const Actions = styled.div.withConfig({
  displayName: "Style__Actions",
  componentId: "sc-14ll30y-7"
})(["margin-top:16px;text-align:right;button + button,button + a{margin-left:12px;}button,a{", " ", "}", ""], buttonStyle, media.xxs`
      padding ${({
  hasSmallButtons
}) => hasSmallButtons ? '5px 7px' : '5px 20px'}
    `, media.xxs`
    display: flex;
    justify-content: flex-end;
    margin-top: 20px;
  `);
const Default = css(["padding:28px 32px 32px;", "{", "}", "{", "}", "{", "}", " ", " ", ""], Body, media.sm`
      flex-direction: column;
    `, Content, media.sm`
      margin-top: 12px;
    `, Logo, media.sm`
      margin-top: 0;
    `, media.md`
    padding: 24px 32px 28px;
  `, media.sm`
    padding: 24px 32px 28px 24px;
  `, media.xxs`
    padding: 24px 16px 28px;
  `);
const Return = css(["padding:28px 32px 32px;", "{", "}", "{", "}", "{", "}", " ", " ", ""], Body, media.sm`
      flex-direction: column;
    `, Content, media.sm`
      margin-top: 12px;
    `, Logo, media.sm`
      margin-top 0;
    `, media.md`
    padding: 24px 24px 32px 32px;
  `, media.sm`
    padding: 24px 24px 32px;
  `, media.xxs`
    padding: 24px 16px 32px;
  `);
const Status = css(["padding:20px 32px;", "{align-items:center;", "}", "{", "}", "{margin-top:0;}", " ", " ", ""], Body, media.xxs`
      align-items: initial;
      flex-direction: column;
    `, Content, media.xxs`
      margin-top: 16px;
    `, Logo, media.md`
    padding: 24px 32x 28px;
  `, media.sm`
    padding: 24px 32px 24px 24px;
  `, media.xxs`
    padding: 24px 16px 20px;
  `);
const Returned = css(["padding:20px 32px;", "{align-items:center;justify-content:space-between;", " ", "}", "{margin-right:10px;", "}", "{margin-top:0;", "}", "{", "}", "{margin-left:auto;", "}", " ", " ", ""], Body, media.sm`
      margin-top: 14px;
    `, media.xxs`
      flex-direction: column;
      margin-top: 16px;
    `, Content, media.xxs`
      margin-right: 0;
    `, Logo, media.sm`
       display: none;
     `, LogoHead, media.sm`
       display: block;
     `, RemoveWrapper, media.xxs`
      margin-top: 22px;
      margin-left: 0;
    `, media.md`
    padding: 24px 32x 28px;
  `, media.sm`
    padding: 24px 32px 24px 24px;
  `, media.xxs`
    padding: 24px 20px 24px 16px;
  `);
export const OrderInsurance = styled.div.withConfig({
  displayName: "Style__OrderInsurance",
  componentId: "sc-14ll30y-8"
})(["background:", ";border-bottom-right-radius:6px;border-bottom-left-radius:6px;", ";"], ({
  theme: {
    color
  }
}) => color.lightGray, ({
  appearance
}) => {
  switch (appearance) {
    case 'return':
      return Return;
    case 'returned':
      return Returned;
    case 'status':
      return Status;
    default:
      return Default;
  }
});